import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const offence: ApiFunc<`/${typeof API.OFFENCE}`, 'get'> = data =>
  instance.get(API.OFFENCE, {
    params: data,
  })

export const offenceReportList: ApiFunc<`/${typeof API.OFFENCE_REPORT}`, 'get'> = data =>
  instance.get(API.OFFENCE_REPORT, {
    params: data,
  })

export const offenceReportCreate: ApiFunc<`/${typeof API.OFFENCE_REPORT}`, 'post'> = data =>
  instance.post(API.OFFENCE_REPORT, data)

export const offenceReportAll: ApiFunc<`/${typeof API.OFFENCE_REPORT_ALL}`, 'get'> = data =>
  instance.get(API.OFFENCE_REPORT_ALL, {
    params: data,
  })

export const offenceCreate: ApiFunc<`/${typeof API.OFFENCE}`, 'post'> = data => instance.post(API.OFFENCE, data)

export const offencePublish: ApiFunc<`/${typeof API.ASSESSMENT_OFFENCE_PUBLISH}`, 'put'> = data => {
  return instance.put(API.ASSESSMENT_OFFENCE_PUBLISH, data)
}
export const offenceUnpublish: ApiFunc<`/${typeof API.ASSESSMENT_OFFENCE_UNPUBLISH}`, 'put'> = data =>
  instance.put(API.ASSESSMENT_OFFENCE_UNPUBLISH, data)

export const offenceGetById: ApiFunc<`/${typeof API.OFFENCE}{id}`, 'get'> = data =>
  instance.get(`${API.OFFENCE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const offenceDeleteById: ApiFunc<`/${typeof API.OFFENCE}{id}`, 'delete'> = data =>
  instance.delete(`${API.OFFENCE}${'id' in data ? prop('id', data) : data?.name}`)

export const offenceAll: ApiFunc<`/${typeof API.OFFENCE_ALL}`, 'get'> = data =>
  instance.get(API.OFFENCE_ALL, {
    params: data,
  })

export const offenceInvigilation: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION}`, 'get'> = data =>
  instance.get(API.OFFENCE_INVIGILATION, {
    params: data,
  })

export const offenceInvigilationCreate: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION}`, 'post'> = data =>
  instance.post(API.OFFENCE_INVIGILATION, data)

export const offenceInvigilationGetById: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION}{id}`, 'get'> = data =>
  instance.get(`${API.OFFENCE_INVIGILATION}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const offenceInvigilationDeleteById: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION}{id}`, 'delete'> = data =>
  instance.delete(`${API.OFFENCE_INVIGILATION}${'id' in data ? prop('id', data) : data?.name}`)

export const offenceInvigilationAll: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION_ALL}`, 'get'> = data =>
  instance.get(API.OFFENCE_INVIGILATION_ALL, {
    params: data,
  })

export const offenceInvigilationMinutes: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION_MINUTES}`, 'get'> = data =>
  instance.get(API.OFFENCE_INVIGILATION_MINUTES, {
    params: data,
  })

export const offenceInvigilationMinutesCreate: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION_MINUTES}`, 'post'> = data =>
  instance.post(API.OFFENCE_INVIGILATION_MINUTES, data)

export const offenceInvigilationMinutesGetById: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_MINUTES}{id}`,
  'get'
> = data =>
  instance.get(`${API.OFFENCE_INVIGILATION_MINUTES}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const offenceInvigilationMinutesDeleteById: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_MINUTES}{id}`,
  'delete'
> = data => instance.delete(`${API.OFFENCE_INVIGILATION_MINUTES}${'id' in data ? prop('id', data) : data?.name}`)

export const offenceInvigilationMinutesAll: ApiFunc<`/${typeof API.OFFENCE_INVIGILATION_MINUTES_ALL}`, 'get'> = data =>
  instance.get(API.OFFENCE_INVIGILATION_MINUTES_ALL, {
    params: data,
  })

export const offenceInvigilationConsultations: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}`,
  'get'
> = data =>
  instance.get(API.OFFENCE_INVIGILATION_CONSULTATIONS, {
    params: data,
  })

export const offenceInvigilationConsultationsCreate: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}`,
  'post'
> = data => instance.post(API.OFFENCE_INVIGILATION_CONSULTATIONS, data)

export const offenceInvigilationConsultationsGetById: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}{id}`,
  'get'
> = data =>
  instance.get(`${API.OFFENCE_INVIGILATION_CONSULTATIONS}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const offenceInvigilationConsultationsDeleteById: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}{id}`,
  'delete'
> = data => instance.delete(`${API.OFFENCE_INVIGILATION_CONSULTATIONS}${'id' in data ? prop('id', data) : data?.name}`)

export const offenceInvigilationConsultationsAll: ApiFunc<
  `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS_ALL}`,
  'get'
> = data =>
  instance.get(API.OFFENCE_INVIGILATION_CONSULTATIONS_ALL, {
    params: data,
  })

export const offenceType: ApiFunc<`/${typeof API.OFFENCE_TYPE}`, 'get'> = data =>
  instance.get(API.OFFENCE_TYPE, {
    params: data,
  })

export const offenceTypeCreate: ApiFunc<`/${typeof API.OFFENCE_TYPE}`, 'post'> = data =>
  instance.post(API.OFFENCE_TYPE, data)

export const offenceTypeGetById: ApiFunc<`/${typeof API.OFFENCE_TYPE}{id}`, 'get'> = data =>
  instance.get(`${API.OFFENCE_TYPE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const offenceTypeDeleteById: ApiFunc<`/${typeof API.OFFENCE_TYPE}{id}`, 'delete'> = data =>
  instance.delete(`${API.OFFENCE_TYPE}${'id' in data ? prop('id', data) : data?.name}`)

export const offenceTypeAll: ApiFunc<`/${typeof API.OFFENCE_TYPE_ALL}`, 'get'> = data =>
  instance.get(API.OFFENCE_TYPE_ALL, {
    params: data,
  })

export const offenceChangeStatus: ApiFunc<`/${typeof API.OFFENCE_CHANGE_STATUS}`, 'put'> = data =>
  instance.put(API.OFFENCE_CHANGE_STATUS, data)

export const offenceChangeSubjectBoardStatus: ApiFunc<
  `${typeof API.OFFENCE_CHANGE_SUBJECT_BOARD_STATUS}`,
  'put'
> = data => instance.put(API.OFFENCE_CHANGE_SUBJECT_BOARD_STATUS, data)

export const reportMisconduct: ApiFunc<`${typeof API.REPORT_MISCONDUCT}`, 'post'> = data =>
  instance.post(API.REPORT_MISCONDUCT, data)

export const offenceUpdated: ApiFunc<`/${typeof API.OFFENCE_UPDATED}`, 'get'> = params =>
  instance.get(API.OFFENCE_UPDATED, {
    params,
  })

export const offenceUpdatedById: ApiFunc<`/${typeof API.OFFENCE_UPDATED}/{id}`, 'get'> = params =>
  instance.get(`${API.OFFENCE_UPDATED}/${params.id}`, {
    params: 'id' in params ? dissoc('id', params) : dissoc('name', params),
  })
